// Maps each of Polly's ~14 visemes to a crude mouth openness. This is the single
// source of truth for "how open is the mouth on this phoneme" across the player:
//   - LipSyncPortrait's small-mode mouth stretches an ellipse per viseme.
//   - the speech visualizers (speechViz/) reuse `openY` as the trace amplitude
//     via useVisemeEnvelope.
//
//   openY: vertical opening (0 closed .. 1 wide) — also the scope amplitude
//   wide:  horizontal spread (mouth corners, e.g. 'ee' vs 'oo')
//
// Visemes: p t S T f k i r s u @ a e o, plus 'sil' (silence / closed).
export const VISEME_SHAPE = {
  sil: { openY: 0.04, wide: 0.5 }, // closed / silence
  p: { openY: 0.04, wide: 0.5 }, // p b m — lips together
  f: { openY: 0.12, wide: 0.55 }, // f v
  T: { openY: 0.18, wide: 0.55 }, // th
  t: { openY: 0.22, wide: 0.6 }, // t d n
  s: { openY: 0.2, wide: 0.7 }, // s z
  S: { openY: 0.3, wide: 0.55 }, // sh ch
  k: { openY: 0.28, wide: 0.55 }, // k g
  i: { openY: 0.25, wide: 0.85 }, // ee — wide
  r: { openY: 0.3, wide: 0.55 }, // r
  e: { openY: 0.45, wide: 0.75 }, // eh
  '@': { openY: 0.55, wide: 0.6 }, // schwa
  a: { openY: 0.85, wide: 0.6 }, // ah — open
  o: { openY: 0.6, wide: 0.4 }, // oh — rounded
  u: { openY: 0.45, wide: 0.3 }, // oo — pursed
}
